export * from './max.js';
export * from './monetization.js';
export * from './types.js';
export * from './vk.js';
export * from './web.js';
import { MaxPlatformAdapter } from './max.js';
import { VkPlatformAdapter } from './vk.js';
import { WebPlatformAdapter } from './web.js';
export const isVkLaunchContext = (locationValue, referrer, framed) => {
    if (/[?&#]vk_app_id=/.test(locationValue))
        return true;
    if (!framed || !referrer)
        return false;
    try {
        const hostname = new URL(referrer).hostname.toLowerCase();
        return hostname === 'vk.com' || hostname.endsWith('.vk.com') || hostname === 'vk.ru';
    }
    catch {
        return false;
    }
};
export const detectEmbeddedPlatformLaunch = () => {
    if (typeof window === 'undefined')
        return null;
    if (window.WebApp && typeof window.WebApp.initData === 'string' && window.WebApp.initData)
        return 'max';
    let framed = false;
    try {
        framed = window.self !== window.top;
    }
    catch {
        framed = true;
    }
    return isVkLaunchContext(`${window.location.search}${window.location.hash}`, typeof document === 'undefined' ? '' : document.referrer, framed)
        ? 'vk'
        : null;
};
export const isEmbeddedPlatformLaunch = () => detectEmbeddedPlatformLaunch() !== null;
export const createPlatformAdapter = (platform) => {
    if (platform === 'vk')
        return new VkPlatformAdapter();
    if (platform === 'max')
        return new MaxPlatformAdapter();
    if (platform === 'web')
        return new WebPlatformAdapter();
    if (typeof window === 'undefined')
        return new WebPlatformAdapter();
    const detectedPlatform = detectEmbeddedPlatformLaunch();
    if (detectedPlatform === 'max')
        return new MaxPlatformAdapter();
    if (detectedPlatform === 'vk')
        return new VkPlatformAdapter();
    return new WebPlatformAdapter();
};
